<p-dropdown
  *ngIf="indicatorsToShow && indicatorsToShow.length"
  (ngModelChange)="onChange($event)"
  [options]="indicatorsToShow"
  [(ngModel)]="selection"
  placeholder="auswählen..."
  optionLabel="name"
  dataKey="_id">
  <ng-template let-item pTemplate="selectedItem">
    <div class="flex align-items-center gap-2">
      <i class="fas fa-ruler-vertical"></i>
      <span>{{ item.name }}</span>
    </div>
  </ng-template>
  <ng-template let-item pTemplate="item">
    <div class="flex align-items-center gap-2">
      <i class="fas fa-ruler-vertical"></i>
      <span>{{ item.name }}</span>
    </div>
  </ng-template>
</p-dropdown>
